// Exact glyphs exported from the GravyWork 2.0 Baseline Figma file (see
// dependability-ui-screenshots/figma-assets/). Stroke colors are lifted to
// currentColor so each icon inherits its host chip/button color.

export const CheckCircleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M6 8.5L7.5 10L10 6.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExclamationTriangleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M7.99887 6.00004V8.50004M1.79671 10.7505C1.21978 11.7505 1.9415 13 3.09599 13H12.9018C14.0562 13 14.778 11.7505 14.201 10.7505L9.29815 2.25213C8.72091 1.25157 7.27684 1.25157 6.69959 2.25213L1.79671 10.7505ZM7.99887 10.5H8.00387V10.505H7.99887V10.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoTipIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M7.5 7.50452L7.52766 7.49069C7.90974 7.29965 8.33994 7.64475 8.23634 8.05917L7.76366 9.94987C7.66006 10.3643 8.09026 10.7094 8.47234 10.5183L8.5 10.5045M14 8.00452C14 11.3182 11.3137 14.0045 8 14.0045C4.68629 14.0045 2 11.3182 2 8.00452C2 4.69081 4.68629 2.00452 8 2.00452C11.3137 2.00452 14 4.69081 14 8.00452ZM8 5.50452H8.005V5.50952H8V5.50452Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoTipIcon20 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M9.375 9.38074L9.40957 9.36345C9.88717 9.12465 10.4249 9.55602 10.2954 10.0741L9.70458 12.4374C9.57507 12.9555 10.1128 13.3868 10.5904 13.148L10.625 13.1307M17.5 10.0057C17.5 14.1479 14.1421 17.5057 10 17.5057C5.85786 17.5057 2.5 14.1479 2.5 10.0057C2.5 5.8636 5.85786 2.50574 10 2.50574C14.1421 2.50574 17.5 5.8636 17.5 10.0057ZM10 6.88074H10.0063V6.88699H10V6.88074Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XMarkIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M6 18.0068L18 6.00684M6 6.00684L18 18.0068"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// The tier popover's 60×60 medal (export 37858:32623 — Gold frame). The
// artwork is a white shield with a tier-colored star and a soft tinted drop
// shadow; only the Gold variant exists in the design file, so other tiers
// reuse the shape with their own tierColor (documented generalization).
// viewBox is 67×71 because the export includes the shadow bleed around the
// 60×60 layout box.
export const PopoverMedal = ({
  tier,
  color,
}: {
  tier: string;
  color: string;
}) => {
  const filterId = `dep-medal-shadow-${tier}`;
  return (
    <svg
      width="67"
      height="71"
      viewBox="0 0 67 71"
      fill="none"
      aria-hidden="true"
      data-testid="popover-medal"
      style={{ flex: 'none', margin: '-5.5px -3.5px' }}
    >
      <g filter={`url(#${filterId})`}>
        <path
          d="M9.37671 18.9624L32.7873 7.34135L57.6255 18.9624C57.6255 34.3602 52.2011 52.3728 32.7873 59.636C13.1452 52.1985 8.99606 29.4213 9.37671 18.9624Z"
          fill="white"
        />
      </g>
      <path
        d="M57.6251 18.9621C57.6251 34.3599 52.2006 52.3724 32.7869 59.6356C13.145 52.1981 8.99606 29.421 9.37672 18.9621L32.7869 7.34098L57.6251 18.9621ZM29.1443 26.5027L19.1427 27.8216L26.4593 34.767L24.6228 44.6871L33.4891 39.8749L42.3565 44.6871L40.519 34.767L47.8366 27.8216L37.8339 26.5027L33.4891 17.3976L29.1443 26.5027Z"
        fill={color}
      />
      <defs>
        <filter
          id={filterId}
          x="0"
          y="0"
          width="67"
          height="71"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow
            dx="0"
            dy="2"
            stdDeviation="4.65"
            floodColor={color}
            floodOpacity="0.5"
          />
        </filter>
      </defs>
    </svg>
  );
};

// heroicons-solid/flag at 16px — the Location flag badge (GRAVY-10365). Solid, not
// outline: the Figma uses the filled glyph wherever a flag is UNRESOLVED, and the badge
// only ever counts outstanding flags.
export const FlagSolidIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M2.5 1.5V14.5M2.5 2.5L5.35 1.79C7.06 1.36 8.86 1.62 10.38 2.5C11.63 3.23 13.13 3.44 14.54 3.09L14.6 3.07C14.9 3 15.2 3.22 15.2 3.53V9.7C15.2 9.93 15.05 10.13 14.83 10.19L14.54 10.26C13.13 10.61 11.63 10.4 10.38 9.68C8.86 8.79 7.06 8.53 5.35 8.96L2.5 9.67"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// The same glyph at 20px — the Figma draws the flag at 16 in the badge (39577:150638)
// but at 20 inside the Location Flag modal's headline row (39583:152151).
export const FlagSolidIcon20 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M2.5 1.5V14.5M2.5 2.5L5.35 1.79C7.06 1.36 8.86 1.62 10.38 2.5C11.63 3.23 13.13 3.44 14.54 3.09L14.6 3.07C14.9 3 15.2 3.22 15.2 3.53V9.7C15.2 9.93 15.05 10.13 14.83 10.19L14.54 10.26C13.13 10.61 11.63 10.4 10.38 9.68C8.86 8.79 7.06 8.53 5.35 8.96L2.5 9.67"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
